import { useState, useEffect } from 'react';
import {
  CartProduct, CommerceService, IProductMetadata, IProductMetadataError,
} from '../../../../services';

const fetchProduct = (
  { productMetadataPageUniqueId: id }: CartProduct,
): Promise<IProductMetadata | IProductMetadataError> => CommerceService
  .getProduct(id)
  .then((result: IProductMetadata) => result)
  .catch((result: IProductMetadataError) => result);

export const useProducts = (cart: CartProduct[]) => {
  const [isFetchingProducts, setIsFetchingProducts] = useState(true);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const getProducts = async () => {
      setIsFetchingProducts(true);

      const cartProducts = await Promise.all(cart.map(fetchProduct));

      setProducts(cartProducts);
      setIsFetchingProducts(false);
    };

    getProducts();
  }, [cart.length]);

  return {
    isFetchingProducts,
    products,
  };
};
